import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterOutlet } from "@angular/router";
import { LoaderComponent } from 'src/app/core/components/loader/loader.component';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss',
    standalone: true,
    imports: [
        CommonModule,
        RouterOutlet,
        LoaderComponent,
    ]
})
export class AppComponent  {

    constructor(

    ) {

    }
}
